import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

// 로딩 중 보여줄 온보딩 일러스트 프레임(디자이너 제공 정적 SVG).
const FRAME_1 = `<svg width="667" height="304" viewBox="0 0 667 304" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_4886_256103)">
<rect x="3.2002" y="3.19922" width="660" height="296.8" rx="6.4" fill="white"/>
<rect x="3.53704" y="3.53606" width="659.326" height="296.126" rx="6.06316" stroke="#93C5FD" stroke-width="0.673684"/>
<path d="M331.856 210.882V165.071C331.856 158.374 326.427 152.945 319.73 152.945H272.235V150.25H319.73C327.916 150.25 334.551 156.886 334.551 165.071V210.882C334.551 217.579 339.98 223.008 346.677 223.008H394.172V225.703H346.677C338.492 225.703 331.856 219.067 331.856 210.882Z" fill="#E5E5E5"/>
<mask id="mask0_4886_256103" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="272" y="150" width="123" height="76">
<path d="M331.858 210.882V165.071C331.858 158.374 326.429 152.945 319.732 152.945H272.237V150.25H319.732C327.917 150.25 334.553 156.886 334.553 165.071V210.882C334.553 217.579 339.982 223.008 346.679 223.008H394.174V225.703H346.679C338.493 225.703 331.858 219.067 331.858 210.882Z" fill="#E5E5E5"/>
</mask>
<g mask="url(#mask0_4886_256103)">
<rect x="337.583" y="169.113" width="8.08421" height="6.06316" transform="rotate(90 337.583 169.113)" fill="url(#paint0_linear_4886_256103)"/>
</g>
<path d="M272.234 151.598H319.729C327.17 151.598 333.202 145.565 333.202 138.124V92.3135C333.202 84.8722 339.235 78.8398 346.676 78.8398H394.171" stroke="#E5E5E5" stroke-width="2.69474"/>
<path d="M272.234 151.596H321.076C327.773 151.596 333.202 146.167 333.202 139.47C333.202 132.773 338.631 127.344 345.329 127.344H394.171" stroke="#E5E5E5" stroke-width="2.69474"/>
<path d="M272.234 151.598H321.076C327.773 151.598 333.202 157.027 333.202 163.724C333.202 170.421 338.631 175.85 345.329 175.85H394.171" stroke="#E5E5E5" stroke-width="2.69474"/>
<rect x="349.034" y="125.996" width="8.08421" height="2.69474" fill="url(#paint1_linear_4886_256103)"/>
<rect x="287.728" y="150.25" width="8.08421" height="2.69474" fill="url(#paint2_linear_4886_256103)"/>
<rect x="387.434" y="174.504" width="8.08421" height="2.69474" fill="url(#paint3_linear_4886_256103)"/>
<mask id="mask1_4886_256103" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="272" y="77" width="123" height="76">
<path d="M331.856 138.124V92.3132C331.856 84.1278 338.492 77.4922 346.677 77.4922H394.172V80.1869H346.677C339.98 80.1869 334.551 85.6161 334.551 92.3132V138.124C334.551 146.309 327.916 152.945 319.73 152.945H272.235V150.25H319.73C326.427 150.25 331.856 144.821 331.856 138.124Z" fill="#E5E5E5"/>
</mask>
<g mask="url(#mask1_4886_256103)">
<rect x="332.42" y="78.7305" width="8.75789" height="8.08421" fill="url(#paint4_linear_4886_256103)"/>
</g>
<g filter="url(#filter1_dd_4886_256103)">
<rect x="191.389" y="97.7031" width="80.8421" height="107.789" rx="5.38947" fill="white"/>
<rect x="191.726" y="98.04" width="80.1684" height="107.116" rx="5.05263" stroke="#F5F5F5" stroke-width="0.673684"/>
<rect x="198.128" y="115.219" width="32.3368" height="5.38947" rx="2.69474" fill="#94A3B8"/>
<rect x="198.128" y="130.715" width="67.3684" height="2.69474" rx="1.34737" fill="#94A3B8"/>
<rect x="198.128" y="136.777" width="49.1789" height="2.69474" rx="1.34737" fill="#94A3B8"/>
<g clip-path="url(#clip0_4886_256103)">
<rect x="198.128" y="149.578" width="67.3684" height="37.8778" rx="1.62334" fill="#FAFAFA"/>
<rect width="67.3684" height="4.32889" transform="translate(198.129 149.578)" fill="#94A3B8"/>
<g clip-path="url(#clip1_4886_256103)">
<mask id="path-21-inside-1_4886_256103" fill="white">
<path d="M198.129 153.906H284.707V158.776H198.129V153.906Z"/>
</mask>
<mask id="path-23-inside-2_4886_256103" fill="white">
<path d="M198.129 153.906H215.986V158.776H198.129V153.906Z"/>
</mask>
<path d="M198.129 153.906H215.986V158.776H198.129V153.906Z" fill="white"/>
<path d="M215.986 153.906H215.715V158.776H215.986H216.256V153.906H215.986Z" fill="#CBD5E1" mask="url(#path-23-inside-2_4886_256103)"/>
<rect x="199.752" y="155.531" width="14.61" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-26-inside-3_4886_256103" fill="white">
<path d="M215.985 153.906H226.808V158.776H215.985V153.906Z"/>
</mask>
<path d="M215.985 153.906H226.808V158.776H215.985V153.906Z" fill="white"/>
<path d="M226.808 153.906H226.537V158.776H226.808H227.078V153.906H226.808Z" fill="#CBD5E1" mask="url(#path-26-inside-3_4886_256103)"/>
<rect x="217.609" y="155.531" width="5.95223" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-29-inside-4_4886_256103" fill="white">
<path d="M226.808 153.906H240.335V158.776H226.808V153.906Z"/>
</mask>
<path d="M226.808 153.906H240.335V158.776H226.808V153.906Z" fill="white"/>
<path d="M240.335 153.906H240.065V158.776H240.335H240.606V153.906H240.335Z" fill="#CBD5E1" mask="url(#path-29-inside-4_4886_256103)"/>
<rect x="228.431" y="155.531" width="8.92834" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-32-inside-5_4886_256103" fill="white">
<path d="M240.335 153.906H267.391V158.776H240.335V153.906Z"/>
</mask>
<path d="M240.335 153.906H267.391V158.776H240.335V153.906Z" fill="white"/>
<path d="M267.391 153.906H267.12V158.776H267.391H267.662V153.906H267.391Z" fill="#CBD5E1" mask="url(#path-32-inside-5_4886_256103)"/>
<rect x="241.959" y="155.531" width="23.8089" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
</g>
<path d="M284.707 158.776V158.506H198.129V158.776V159.047H284.707V158.776Z" fill="#CBD5E1" mask="url(#path-21-inside-1_4886_256103)"/>
<g clip-path="url(#clip2_4886_256103)">
<mask id="path-35-inside-6_4886_256103" fill="white">
<path d="M198.129 158.777H284.707V163.647H198.129V158.777Z"/>
</mask>
<mask id="path-37-inside-7_4886_256103" fill="white">
<path d="M198.129 158.777H215.986V163.647H198.129V158.777Z"/>
</mask>
<path d="M198.129 158.777H215.986V163.647H198.129V158.777Z" fill="white"/>
<path d="M215.986 158.777H215.715V163.647H215.986H216.256V158.777H215.986Z" fill="#CBD5E1" mask="url(#path-37-inside-7_4886_256103)"/>
<rect x="199.752" y="160.402" width="14.61" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-40-inside-8_4886_256103" fill="white">
<path d="M215.985 158.777H226.808V163.647H215.985V158.777Z"/>
</mask>
<path d="M215.985 158.777H226.808V163.647H215.985V158.777Z" fill="white"/>
<path d="M226.808 158.777H226.537V163.647H226.808H227.078V158.777H226.808Z" fill="#CBD5E1" mask="url(#path-40-inside-8_4886_256103)"/>
<rect x="217.609" y="160.402" width="5.95223" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-43-inside-9_4886_256103" fill="white">
<path d="M226.808 158.777H240.335V163.647H226.808V158.777Z"/>
</mask>
<path d="M226.808 158.777H240.335V163.647H226.808V158.777Z" fill="white"/>
<path d="M240.335 158.777H240.065V163.647H240.335H240.606V158.777H240.335Z" fill="#CBD5E1" mask="url(#path-43-inside-9_4886_256103)"/>
<rect x="228.431" y="160.402" width="10.2811" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-46-inside-10_4886_256103" fill="white">
<path d="M240.335 158.777H267.391V163.647H240.335V158.777Z"/>
</mask>
<path d="M240.335 158.777H267.391V163.647H240.335V158.777Z" fill="white"/>
<path d="M267.391 158.777H267.12V163.647H267.391H267.662V158.777H267.391Z" fill="#CBD5E1" mask="url(#path-46-inside-10_4886_256103)"/>
<rect x="241.959" y="160.402" width="16.2334" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
</g>
<path d="M284.707 163.647V163.377H198.129V163.647V163.918H284.707V163.647Z" fill="#CBD5E1" mask="url(#path-35-inside-6_4886_256103)"/>
<g clip-path="url(#clip3_4886_256103)">
<mask id="path-49-inside-11_4886_256103" fill="white">
<path d="M198.129 163.645H284.707V168.515H198.129V163.645Z"/>
</mask>
<mask id="path-51-inside-12_4886_256103" fill="white">
<path d="M198.129 163.645H215.986V168.515H198.129V163.645Z"/>
</mask>
<path d="M198.129 163.645H215.986V168.515H198.129V163.645Z" fill="white"/>
<path d="M215.986 163.645H215.715V168.515H215.986H216.256V163.645H215.986Z" fill="#CBD5E1" mask="url(#path-51-inside-12_4886_256103)"/>
<rect x="199.752" y="165.27" width="14.61" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-54-inside-13_4886_256103" fill="white">
<path d="M215.985 163.645H226.808V168.515H215.985V163.645Z"/>
</mask>
<path d="M215.985 163.645H226.808V168.515H215.985V163.645Z" fill="white"/>
<path d="M226.808 163.645H226.537V168.515H226.808H227.078V163.645H226.808Z" fill="#CBD5E1" mask="url(#path-54-inside-13_4886_256103)"/>
<rect x="217.609" y="165.27" width="5.41112" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-57-inside-14_4886_256103" fill="white">
<path d="M226.808 163.645H240.335V168.515H226.808V163.645Z"/>
</mask>
<path d="M226.808 163.645H240.335V168.515H226.808V163.645Z" fill="white"/>
<path d="M240.335 163.645H240.065V168.515H240.335H240.606V163.645H240.335Z" fill="#CBD5E1" mask="url(#path-57-inside-14_4886_256103)"/>
<rect x="228.431" y="165.27" width="6.7639" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-60-inside-15_4886_256103" fill="white">
<path d="M240.335 163.645H267.391V168.515H240.335V163.645Z"/>
</mask>
<path d="M240.335 163.645H267.391V168.515H240.335V163.645Z" fill="white"/>
<path d="M267.391 163.645H267.12V168.515H267.391H267.662V163.645H267.391Z" fill="#CBD5E1" mask="url(#path-60-inside-15_4886_256103)"/>
<rect x="241.959" y="165.27" width="20.0211" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
</g>
<path d="M284.707 168.515V168.244H198.129V168.515V168.785H284.707V168.515Z" fill="#CBD5E1" mask="url(#path-49-inside-11_4886_256103)"/>
<g clip-path="url(#clip4_4886_256103)">
<mask id="path-63-inside-16_4886_256103" fill="white">
<path d="M198.129 168.516H284.707V173.386H198.129V168.516Z"/>
</mask>
<mask id="path-65-inside-17_4886_256103" fill="white">
<path d="M198.129 168.516H215.986V173.386H198.129V168.516Z"/>
</mask>
<path d="M198.129 168.516H215.986V173.386H198.129V168.516Z" fill="white"/>
<path d="M215.986 168.516H215.715V173.386H215.986H216.256V168.516H215.986Z" fill="#CBD5E1" mask="url(#path-65-inside-17_4886_256103)"/>
<rect x="199.752" y="170.141" width="14.61" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-68-inside-18_4886_256103" fill="white">
<path d="M215.985 168.516H226.808V173.386H215.985V168.516Z"/>
</mask>
<path d="M215.985 168.516H226.808V173.386H215.985V168.516Z" fill="white"/>
<path d="M226.808 168.516H226.537V173.386H226.808H227.078V168.516H226.808Z" fill="#CBD5E1" mask="url(#path-68-inside-18_4886_256103)"/>
<rect x="217.609" y="170.141" width="6.7639" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-71-inside-19_4886_256103" fill="white">
<path d="M226.808 168.516H240.335V173.386H226.808V168.516Z"/>
</mask>
<path d="M226.808 168.516H240.335V173.386H226.808V168.516Z" fill="white"/>
<path d="M240.335 168.516H240.065V173.386H240.335H240.606V168.516H240.335Z" fill="#CBD5E1" mask="url(#path-71-inside-19_4886_256103)"/>
<rect x="228.431" y="170.141" width="10.2811" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-74-inside-20_4886_256103" fill="white">
<path d="M240.335 168.516H267.391V173.386H240.335V168.516Z"/>
</mask>
<path d="M240.335 168.516H267.391V173.386H240.335V168.516Z" fill="white"/>
<path d="M267.391 168.516H267.12V173.386H267.391H267.662V168.516H267.391Z" fill="#CBD5E1" mask="url(#path-74-inside-20_4886_256103)"/>
<rect x="241.959" y="170.141" width="13.7984" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
</g>
<path d="M284.707 173.386V173.115H198.129V173.386V173.656H284.707V173.386Z" fill="#CBD5E1" mask="url(#path-63-inside-16_4886_256103)"/>
<g clip-path="url(#clip5_4886_256103)">
<mask id="path-77-inside-21_4886_256103" fill="white">
<path d="M198.129 173.387H284.707V178.257H198.129V173.387Z"/>
</mask>
<mask id="path-79-inside-22_4886_256103" fill="white">
<path d="M198.129 173.387H215.986V178.257H198.129V173.387Z"/>
</mask>
<path d="M198.129 173.387H215.986V178.257H198.129V173.387Z" fill="white"/>
<path d="M215.986 173.387H215.715V178.257H215.986H216.256V173.387H215.986Z" fill="#CBD5E1" mask="url(#path-79-inside-22_4886_256103)"/>
<rect x="199.752" y="175.012" width="14.61" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-82-inside-23_4886_256103" fill="white">
<path d="M215.985 173.387H226.808V178.257H215.985V173.387Z"/>
</mask>
<path d="M215.985 173.387H226.808V178.257H215.985V173.387Z" fill="white"/>
<path d="M226.808 173.387H226.537V178.257H226.808H227.078V173.387H226.808Z" fill="#CBD5E1" mask="url(#path-82-inside-23_4886_256103)"/>
<rect x="217.609" y="175.012" width="5.95223" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-85-inside-24_4886_256103" fill="white">
<path d="M226.808 173.387H240.335V178.257H226.808V173.387Z"/>
</mask>
<path d="M226.808 173.387H240.335V178.257H226.808V173.387Z" fill="white"/>
<path d="M240.335 173.387H240.065V178.257H240.335H240.606V173.387H240.335Z" fill="#CBD5E1" mask="url(#path-85-inside-24_4886_256103)"/>
<rect x="228.431" y="175.012" width="8.11668" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-88-inside-25_4886_256103" fill="white">
<path d="M240.335 173.387H267.391V178.257H240.335V173.387Z"/>
</mask>
<path d="M240.335 173.387H267.391V178.257H240.335V173.387Z" fill="white"/>
<path d="M267.391 173.387H267.12V178.257H267.391H267.662V173.387H267.391Z" fill="#CBD5E1" mask="url(#path-88-inside-25_4886_256103)"/>
<rect x="241.959" y="175.012" width="23.8089" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
</g>
<path d="M284.707 178.257V177.986H198.129V178.257V178.527H284.707V178.257Z" fill="#CBD5E1" mask="url(#path-77-inside-21_4886_256103)"/>
<g clip-path="url(#clip6_4886_256103)">
<mask id="path-91-inside-26_4886_256103" fill="white">
<path d="M198.129 178.258H284.707V183.128H198.129V178.258Z"/>
</mask>
<mask id="path-93-inside-27_4886_256103" fill="white">
<path d="M198.129 178.258H215.986V183.128H198.129V178.258Z"/>
</mask>
<path d="M198.129 178.258H215.986V183.128H198.129V178.258Z" fill="white"/>
<path d="M215.986 178.258H215.715V183.128H215.986H216.256V178.258H215.986Z" fill="#CBD5E1" mask="url(#path-93-inside-27_4886_256103)"/>
<rect x="199.752" y="179.883" width="14.61" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-96-inside-28_4886_256103" fill="white">
<path d="M215.985 178.258H226.808V183.128H215.985V178.258Z"/>
</mask>
<path d="M215.985 178.258H226.808V183.128H215.985V178.258Z" fill="white"/>
<path d="M226.808 178.258H226.537V183.128H226.808H227.078V178.258H226.808Z" fill="#CBD5E1" mask="url(#path-96-inside-28_4886_256103)"/>
<rect x="217.609" y="179.883" width="5.41112" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-99-inside-29_4886_256103" fill="white">
<path d="M226.808 178.258H240.335V183.128H226.808V178.258Z"/>
</mask>
<path d="M226.808 178.258H240.335V183.128H226.808V178.258Z" fill="white"/>
<path d="M240.335 178.258H240.065V183.128H240.335H240.606V178.258H240.335Z" fill="#CBD5E1" mask="url(#path-99-inside-29_4886_256103)"/>
<rect x="228.431" y="179.883" width="8.92834" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-102-inside-30_4886_256103" fill="white">
<path d="M240.335 178.258H267.391V183.128H240.335V178.258Z"/>
</mask>
<path d="M240.335 178.258H267.391V183.128H240.335V178.258Z" fill="white"/>
<path d="M267.391 178.258H267.12V183.128H267.391H267.662V178.258H267.391Z" fill="#CBD5E1" mask="url(#path-102-inside-30_4886_256103)"/>
<rect x="241.959" y="179.883" width="23.8089" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
</g>
<path d="M284.707 183.128V182.857H198.129V183.128V183.398H284.707V183.128Z" fill="#CBD5E1" mask="url(#path-91-inside-26_4886_256103)"/>
<g clip-path="url(#clip7_4886_256103)">
<mask id="path-105-inside-31_4886_256103" fill="white">
<path d="M198.129 183.125H284.707V187.995H198.129V183.125Z"/>
</mask>
<mask id="path-107-inside-32_4886_256103" fill="white">
<path d="M198.129 183.125H215.986V187.995H198.129V183.125Z"/>
</mask>
<path d="M198.129 183.125H215.986V187.995H198.129V183.125Z" fill="white"/>
<path d="M215.986 183.125H215.715V187.995H215.986H216.256V183.125H215.986Z" fill="#CBD5E1" mask="url(#path-107-inside-32_4886_256103)"/>
<rect x="199.752" y="184.75" width="14.61" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-110-inside-33_4886_256103" fill="white">
<path d="M215.985 183.125H226.808V187.995H215.985V183.125Z"/>
</mask>
<path d="M215.985 183.125H226.808V187.995H215.985V183.125Z" fill="white"/>
<path d="M226.808 183.125H226.537V187.995H226.808H227.078V183.125H226.808Z" fill="#CBD5E1" mask="url(#path-110-inside-33_4886_256103)"/>
<rect x="217.609" y="184.75" width="7.57557" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-113-inside-34_4886_256103" fill="white">
<path d="M226.808 183.125H240.335V187.995H226.808V183.125Z"/>
</mask>
<path d="M226.808 183.125H240.335V187.995H226.808V183.125Z" fill="white"/>
<path d="M240.335 183.125H240.065V187.995H240.335H240.606V183.125H240.335Z" fill="#CBD5E1" mask="url(#path-113-inside-34_4886_256103)"/>
<rect x="228.431" y="184.75" width="8.92834" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
<mask id="path-116-inside-35_4886_256103" fill="white">
<path d="M240.335 183.125H267.391V187.995H240.335V183.125Z"/>
</mask>
<path d="M240.335 183.125H267.391V187.995H240.335V183.125Z" fill="white"/>
<path d="M267.391 183.125H267.12V187.995H267.391H267.662V183.125H267.391Z" fill="#CBD5E1" mask="url(#path-116-inside-35_4886_256103)"/>
<rect x="241.959" y="184.75" width="23.8089" height="1.62334" rx="0.811668" fill="#CBD5E1"/>
</g>
<path d="M284.707 187.995V187.724H198.129V187.995V188.266H284.707V187.995Z" fill="#CBD5E1" mask="url(#path-105-inside-31_4886_256103)"/>
</g>
<rect x="198.263" y="149.713" width="67.0979" height="37.6073" rx="1.48806" stroke="#E2E8F0" stroke-width="0.270556"/>
</g>
<g filter="url(#filter2_dd_4886_256103)">
<rect x="394.171" y="62.6719" width="80.8421" height="32.3368" rx="5.38947" fill="#FAFAFA"/>
<rect x="394.508" y="63.0087" width="80.1684" height="31.6632" rx="5.05263" stroke="#F5F5F5" stroke-width="0.673684"/>
</g>
<rect x="402.256" y="72.7773" width="16.7672" height="5.38947" rx="0.59883" fill="#93C5FD"/>
<rect x="402.256" y="80.1875" width="64.6737" height="5.38947" rx="2.69474" fill="#CBD5E1"/>
<g filter="url(#filter3_dd_4886_256103)">
<rect x="394.171" y="111.176" width="80.8421" height="32.3368" rx="5.38947" fill="#FAFAFA"/>
<rect x="394.508" y="111.513" width="80.1684" height="31.6632" rx="5.05263" stroke="#F5F5F5" stroke-width="0.673684"/>
</g>
<rect x="402.256" y="121.281" width="16.7672" height="5.38947" rx="0.59883" fill="#93C5FD"/>
<rect x="402.256" y="128.691" width="64.6737" height="5.38947" rx="2.69474" fill="#CBD5E1"/>
<g filter="url(#filter4_dd_4886_256103)">
<rect x="394.171" y="159.684" width="80.8421" height="32.3368" rx="5.38947" fill="#FAFAFA"/>
<rect x="394.508" y="160.02" width="80.1684" height="31.6632" rx="5.05263" stroke="#F5F5F5" stroke-width="0.673684"/>
</g>
<rect x="402.256" y="169.789" width="16.7672" height="5.38947" rx="0.59883" fill="#93C5FD"/>
<rect x="402.256" y="177.199" width="64.6737" height="5.38947" rx="2.69474" fill="#CBD5E1"/>
<g filter="url(#filter5_dd_4886_256103)">
<rect x="394.171" y="208.188" width="80.8421" height="32.3368" rx="5.38947" fill="#FAFAFA"/>
<rect x="394.508" y="208.524" width="80.1684" height="31.6632" rx="5.05263" stroke="#F5F5F5" stroke-width="0.673684"/>
</g>
<rect x="402.256" y="218.293" width="16.7672" height="5.38947" rx="0.59883" fill="#93C5FD"/>
<rect x="402.256" y="225.703" width="64.6737" height="5.38947" rx="2.69474" fill="#CBD5E1"/>
</g>
<defs>
<filter id="filter0_d_4886_256103" x="0.000195265" y="-0.000781298" width="666.4" height="303.201" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.2" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_4886_256103"/>
<feOffset/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.937255 0 0 0 0 0.964706 0 0 0 0 1 0 0 0 1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4886_256103"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4886_256103" result="shape"/>
</filter>
<filter id="filter1_dd_4886_256103" x="177.915" y="97.7031" width="107.79" height="134.736" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect1_dropShadow_4886_256103"/>
<feOffset dy="6.73684"/>
<feGaussianBlur stdDeviation="3.36842"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4886_256103"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect2_dropShadow_4886_256103"/>
<feOffset dy="13.4737"/>
<feGaussianBlur stdDeviation="8.42105"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_4886_256103" result="effect2_dropShadow_4886_256103"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4886_256103" result="shape"/>
</filter>
<filter id="filter2_dd_4886_256103" x="380.698" y="62.6719" width="107.79" height="59.2833" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect1_dropShadow_4886_256103"/>
<feOffset dy="6.73684"/>
<feGaussianBlur stdDeviation="3.36842"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4886_256103"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect2_dropShadow_4886_256103"/>
<feOffset dy="13.4737"/>
<feGaussianBlur stdDeviation="8.42105"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_4886_256103" result="effect2_dropShadow_4886_256103"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4886_256103" result="shape"/>
</filter>
<filter id="filter3_dd_4886_256103" x="380.698" y="111.176" width="107.79" height="59.2833" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect1_dropShadow_4886_256103"/>
<feOffset dy="6.73684"/>
<feGaussianBlur stdDeviation="3.36842"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4886_256103"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect2_dropShadow_4886_256103"/>
<feOffset dy="13.4737"/>
<feGaussianBlur stdDeviation="8.42105"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_4886_256103" result="effect2_dropShadow_4886_256103"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4886_256103" result="shape"/>
</filter>
<filter id="filter4_dd_4886_256103" x="380.698" y="159.684" width="107.79" height="59.2833" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect1_dropShadow_4886_256103"/>
<feOffset dy="6.73684"/>
<feGaussianBlur stdDeviation="3.36842"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4886_256103"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect2_dropShadow_4886_256103"/>
<feOffset dy="13.4737"/>
<feGaussianBlur stdDeviation="8.42105"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_4886_256103" result="effect2_dropShadow_4886_256103"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4886_256103" result="shape"/>
</filter>
<filter id="filter5_dd_4886_256103" x="380.698" y="208.188" width="107.79" height="59.2833" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect1_dropShadow_4886_256103"/>
<feOffset dy="6.73684"/>
<feGaussianBlur stdDeviation="3.36842"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4886_256103"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.36842" operator="erode" in="SourceAlpha" result="effect2_dropShadow_4886_256103"/>
<feOffset dy="13.4737"/>
<feGaussianBlur stdDeviation="8.42105"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_4886_256103" result="effect2_dropShadow_4886_256103"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4886_256103" result="shape"/>
</filter>
<linearGradient id="paint0_linear_4886_256103" x1="337.583" y1="172.145" x2="345.668" y2="172.145" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B82F6"/>
<stop offset="1" stop-color="#3B82F6"/>
</linearGradient>
<linearGradient id="paint1_linear_4886_256103" x1="349.034" y1="127.343" x2="357.118" y2="127.343" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B82F6"/>
<stop offset="1" stop-color="#3B82F6"/>
</linearGradient>
<linearGradient id="paint2_linear_4886_256103" x1="287.728" y1="151.597" x2="295.812" y2="151.597" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B82F6"/>
<stop offset="1" stop-color="#3B82F6"/>
</linearGradient>
<linearGradient id="paint3_linear_4886_256103" x1="387.434" y1="175.851" x2="395.518" y2="175.851" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B82F6"/>
<stop offset="1" stop-color="#3B82F6"/>
</linearGradient>
<linearGradient id="paint4_linear_4886_256103" x1="332.42" y1="82.7726" x2="341.178" y2="82.7726" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B82F6"/>
<stop offset="1" stop-color="#3B82F6"/>
</linearGradient>
<clipPath id="clip0_4886_256103">
<rect x="198.128" y="149.578" width="67.3684" height="37.8778" rx="1.62334" fill="white"/>
</clipPath>
<clipPath id="clip1_4886_256103">
<path d="M198.129 153.906H284.707V158.776H198.129V153.906Z" fill="white"/>
</clipPath>
<clipPath id="clip2_4886_256103">
<path d="M198.129 158.777H284.707V163.647H198.129V158.777Z" fill="white"/>
</clipPath>
<clipPath id="clip3_4886_256103">
<path d="M198.129 163.645H284.707V168.515H198.129V163.645Z" fill="white"/>
</clipPath>
<clipPath id="clip4_4886_256103">
<path d="M198.129 168.516H284.707V173.386H198.129V168.516Z" fill="white"/>
</clipPath>
<clipPath id="clip5_4886_256103">
<path d="M198.129 173.387H284.707V178.257H198.129V173.387Z" fill="white"/>
</clipPath>
<clipPath id="clip6_4886_256103">
<path d="M198.129 178.258H284.707V183.128H198.129V178.258Z" fill="white"/>
</clipPath>
<clipPath id="clip7_4886_256103">
<path d="M198.129 183.125H284.707V187.995H198.129V183.125Z" fill="white"/>
</clipPath>
</defs>
</svg>`;

const FRAME_2 = `<svg width="667" height="304" viewBox="0 0 667 304" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_4886_256264)">
<rect x="3.2002" y="3.19922" width="660" height="296.8" rx="6.4" fill="white"/>
<rect x="3.53704" y="3.53606" width="659.326" height="296.126" rx="6.06316" stroke="#93C5FD" stroke-width="0.673684"/>
<path d="M325.2 79.5977H149.2C143.677 79.5977 139.2 84.0748 139.2 89.5977V213.598C139.2 219.12 143.677 223.598 149.2 223.598H325.2C330.723 223.598 335.2 219.12 335.2 213.598V89.5977C335.2 84.0748 330.723 79.5977 325.2 79.5977Z" fill="white" stroke="#E5E5E5"/>
<path d="M270.2 98.5977H156.2C154.543 98.5977 153.2 99.9408 153.2 101.598C153.2 103.255 154.543 104.598 156.2 104.598H270.2C271.857 104.598 273.2 103.255 273.2 101.598C273.2 99.9408 271.857 98.5977 270.2 98.5977Z" fill="#DBE2EA"/>
<path d="M317.2 93.5977H285.2C282.991 93.5977 281.2 95.3885 281.2 97.5977V105.598C281.2 107.807 282.991 109.598 285.2 109.598H317.2C319.409 109.598 321.2 107.807 321.2 105.598V97.5977C321.2 95.3885 319.409 93.5977 317.2 93.5977Z" fill="#D6F0E0"/>
<path d="M270.2 123.598H156.2C154.543 123.598 153.2 124.941 153.2 126.598C153.2 128.255 154.543 129.598 156.2 129.598H270.2C271.857 129.598 273.2 128.255 273.2 126.598C273.2 124.941 271.857 123.598 270.2 123.598Z" fill="#DBE2EA"/>
<path d="M317.2 118.598H285.2C282.991 118.598 281.2 120.389 281.2 122.598V130.598C281.2 132.807 282.991 134.598 285.2 134.598H317.2C319.409 134.598 321.2 132.807 321.2 130.598V122.598C321.2 120.389 319.409 118.598 317.2 118.598Z" fill="#D6F0E0"/>
<path d="M270.2 148.598H156.2C154.543 148.598 153.2 149.941 153.2 151.598C153.2 153.255 154.543 154.598 156.2 154.598H270.2C271.857 154.598 273.2 153.255 273.2 151.598C273.2 149.941 271.857 148.598 270.2 148.598Z" fill="#DBE2EA"/>
<path d="M317.2 143.598H285.2C282.991 143.598 281.2 145.389 281.2 147.598V155.598C281.2 157.807 282.991 159.598 285.2 159.598H317.2C319.409 159.598 321.2 157.807 321.2 155.598V147.598C321.2 145.389 319.409 143.598 317.2 143.598Z" fill="#FBE7B0" stroke="#2563EB" stroke-width="2"/>
<path d="M270.2 173.598H156.2C154.543 173.598 153.2 174.941 153.2 176.598C153.2 178.255 154.543 179.598 156.2 179.598H270.2C271.857 179.598 273.2 178.255 273.2 176.598C273.2 174.941 271.857 173.598 270.2 173.598Z" fill="#DBE2EA"/>
<path d="M317.2 168.598H285.2C282.991 168.598 281.2 170.389 281.2 172.598V180.598C281.2 182.807 282.991 184.598 285.2 184.598H317.2C319.409 184.598 321.2 182.807 321.2 180.598V172.598C321.2 170.389 319.409 168.598 317.2 168.598Z" fill="#F7CFCF"/>
<path d="M270.2 198.598H156.2C154.543 198.598 153.2 199.941 153.2 201.598C153.2 203.255 154.543 204.598 156.2 204.598H270.2C271.857 204.598 273.2 203.255 273.2 201.598C273.2 199.941 271.857 198.598 270.2 198.598Z" fill="#DBE2EA"/>
<path d="M317.2 193.598H285.2C282.991 193.598 281.2 195.389 281.2 197.598V205.598C281.2 207.807 282.991 209.598 285.2 209.598H317.2C319.409 209.598 321.2 207.807 321.2 205.598V197.598C321.2 195.389 319.409 193.598 317.2 193.598Z" fill="#D6F0E0"/>
<path d="M323.2 171.598C328.723 171.598 333.2 167.121 333.2 161.598C333.2 156.075 328.723 151.598 323.2 151.598C317.677 151.598 313.2 156.075 313.2 161.598C313.2 167.121 317.677 171.598 323.2 171.598Z" fill="white" stroke="#2563EB" stroke-width="3"/>
<path d="M323.2 165.598C325.409 165.598 327.2 163.807 327.2 161.598C327.2 159.389 325.409 157.598 323.2 157.598C320.991 157.598 319.2 159.389 319.2 161.598C319.2 163.807 320.991 165.598 323.2 165.598Z" fill="#2563EB"/>
<path d="M351.2 151.598H385.2" stroke="#C9D2DC" stroke-width="2"/>
<path d="M385.2 145.598L397.2 151.598L385.2 157.598V145.598Z" fill="#C9D2DC"/>
<path d="M581.2 87.5977H421.2C415.677 87.5977 411.2 92.0748 411.2 97.5977V205.598C411.2 211.121 415.677 215.598 421.2 215.598H581.2C586.723 215.598 591.2 211.121 591.2 205.598V97.5977C591.2 92.0748 586.723 87.5977 581.2 87.5977Z" fill="white" stroke="#E5E5E5"/>
<path d="M572.2 100.598H430.2C426.886 100.598 424.2 103.284 424.2 106.598V122.598C424.2 125.911 426.886 128.598 430.2 128.598H572.2C575.514 128.598 578.2 125.911 578.2 122.598V106.598C578.2 103.284 575.514 100.598 572.2 100.598Z" fill="#FBE7B0"/>
<path d="M436.2 118.098C438.133 118.098 439.7 116.531 439.7 114.598C439.7 112.665 438.133 111.098 436.2 111.098C434.267 111.098 432.7 112.665 432.7 114.598C432.7 116.531 434.267 118.098 436.2 118.098Z" fill="#D98A0B"/>
<path d="M561.2 112.098H449.2C447.543 112.098 446.2 113.217 446.2 114.598C446.2 115.978 447.543 117.098 449.2 117.098H561.2C562.857 117.098 564.2 115.978 564.2 114.598C564.2 113.217 562.857 112.098 561.2 112.098Z" fill="#E9C77E"/>
<path d="M571.45 137.348H430.95C427.636 137.348 424.95 140.034 424.95 143.348V157.848C424.95 161.161 427.636 163.848 430.95 163.848H571.45C574.764 163.848 577.45 161.161 577.45 157.848V143.348C577.45 140.034 574.764 137.348 571.45 137.348Z" stroke="#2563EB" stroke-width="1.5"/>
<path d="M501.2 147.598H437.2C435.543 147.598 434.2 148.941 434.2 150.598C434.2 152.255 435.543 153.598 437.2 153.598H501.2C502.857 153.598 504.2 152.255 504.2 150.598C504.2 148.941 502.857 147.598 501.2 147.598Z" fill="#C3CBD6"/>
<path d="M567.2 143.598H565.2V157.598H567.2V143.598Z" fill="#2563EB"/>
<path d="M572.2 172.598H430.2C426.886 172.598 424.2 175.284 424.2 178.598V190.598C424.2 193.911 426.886 196.598 430.2 196.598H572.2C575.514 196.598 578.2 193.911 578.2 190.598V178.598C578.2 175.284 575.514 172.598 572.2 172.598Z" fill="#171717"/>
<path d="M489.48 179.21V182.696H490.854V183.793H489.48V188.541H488.167V179.21H489.48ZM483.717 179.948V182.225H485.655V179.948H486.958V186.377H482.415V179.948H483.717ZM483.717 185.321H485.655V183.24H483.717V185.321ZM499.734 186.429V187.505H491.192V186.429H494.792V185.024H492.177V181.886H497.458V180.861H492.167V179.815H498.75V182.912H493.489V183.958H498.965V185.024H496.094V186.429H499.734ZM507.64 179.938C507.64 181.035 508.757 182.255 510.9 182.522L510.388 183.578C508.757 183.342 507.563 182.589 506.953 181.579C506.337 182.589 505.153 183.342 503.538 183.578L503.015 182.522C505.138 182.255 506.266 181.035 506.266 179.938V179.487H507.64V179.938ZM511.198 184.286V185.352H507.568V188.541H506.276V185.352H502.687V184.286H511.198ZM519.626 179.21V184.747H518.324V182.542H516.868V181.486H518.324V179.21H519.626ZM516.438 184.952C518.427 184.962 519.647 185.619 519.657 186.757C519.647 187.885 518.427 188.551 516.438 188.551C514.448 188.551 513.228 187.885 513.228 186.757C513.228 185.619 514.448 184.962 516.438 184.952ZM516.438 185.957C515.197 185.957 514.53 186.213 514.53 186.757C514.53 187.29 515.197 187.557 516.438 187.557C517.678 187.557 518.355 187.29 518.355 186.757C518.355 186.213 517.678 185.957 516.438 185.957ZM517.145 179.774V180.82H515.289C515.32 181.907 515.976 183.004 517.432 183.486L516.786 184.511C515.756 184.178 515.048 183.501 514.643 182.655C514.228 183.609 513.484 184.378 512.377 184.757L511.7 183.722C513.233 183.209 513.92 181.989 513.956 180.82H512.08V179.774H517.145Z" fill="white"/>
</g>
<defs>
<filter id="filter0_d_4886_256264" x="0.000195265" y="-0.000781298" width="666.4" height="303.201" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.2" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_4886_256264"/>
<feOffset/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.937255 0 0 0 0 0.964706 0 0 0 0 1 0 0 0 1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4886_256264"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4886_256264" result="shape"/>
</filter>
</defs>
</svg>`;

const FRAME_3 = `<svg width="667" height="304" viewBox="0 0 667 304" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_4886_256514)">
<rect x="3.2002" y="3.19922" width="660" height="296.8" rx="6.4" fill="white"/>
<rect x="3.53704" y="3.53606" width="659.326" height="296.126" rx="6.06316" stroke="#93C5FD" stroke-width="0.673684"/>
<path d="M402.517 83.1211H247.151C240.551 83.1211 235.2 88.4718 235.2 95.0723V195.463C235.2 202.063 240.551 207.414 247.151 207.414H402.517C409.118 207.414 414.468 202.063 414.468 195.463V95.0723C414.468 88.4718 409.118 83.1211 402.517 83.1211Z" fill="white" stroke="#8FD2A4" stroke-width="1.19512"/>
<path d="M321.249 104.035H254.322C252.342 104.035 250.737 105.373 250.737 107.023C250.737 108.673 252.342 110.011 254.322 110.011H321.249C323.229 110.011 324.834 108.673 324.834 107.023C324.834 105.373 323.229 104.035 321.249 104.035Z" fill="#DBE2EA"/>
<path d="M394.152 98.6562H363.078C360.438 98.6562 358.298 100.797 358.298 103.437V110.607C358.298 113.248 360.438 115.388 363.078 115.388H394.152C396.792 115.388 398.932 113.248 398.932 110.607V103.437C398.932 100.797 396.792 98.6562 394.152 98.6562Z" fill="#D6F0E0"/>
<path d="M321.249 130.328H254.322C252.342 130.328 250.737 131.666 250.737 133.316C250.737 134.966 252.342 136.304 254.322 136.304H321.249C323.229 136.304 324.834 134.966 324.834 133.316C324.834 131.666 323.229 130.328 321.249 130.328Z" fill="#DBE2EA"/>
<path d="M394.152 124.949H363.078C360.438 124.949 358.298 127.09 358.298 129.73V136.9C358.298 139.541 360.438 141.681 363.078 141.681H394.152C396.792 141.681 398.932 139.541 398.932 136.9V129.73C398.932 127.09 396.792 124.949 394.152 124.949Z" fill="#D6F0E0"/>
<path d="M321.249 156.621H254.322C252.342 156.621 250.737 157.959 250.737 159.609C250.737 161.259 252.342 162.597 254.322 162.597H321.249C323.229 162.597 324.834 161.259 324.834 159.609C324.834 157.959 323.229 156.621 321.249 156.621Z" fill="#DBE2EA"/>
<path d="M394.152 151.242H363.078C360.438 151.242 358.298 153.382 358.298 156.023V163.193C358.298 165.834 360.438 167.974 363.078 167.974H394.152C396.792 167.974 398.932 165.834 398.932 163.193V156.023C398.932 153.382 396.792 151.242 394.152 151.242Z" fill="#D6F0E0"/>
<path d="M321.249 182.914H254.322C252.342 182.914 250.737 184.252 250.737 185.902C250.737 187.552 252.342 188.89 254.322 188.89H321.249C323.229 188.89 324.834 187.552 324.834 185.902C324.834 184.252 323.229 182.914 321.249 182.914Z" fill="#DBE2EA"/>
<path d="M394.152 177.535H363.078C360.438 177.535 358.298 179.675 358.298 182.316V189.486C358.298 192.127 360.438 194.267 363.078 194.267H394.152C396.792 194.267 398.932 192.127 398.932 189.486V182.316C398.932 179.675 396.792 177.535 394.152 177.535Z" fill="#D6F0E0"/>
<path d="M407.298 111.801C420.499 111.801 431.2 101.099 431.2 87.8985C431.2 74.6976 420.499 63.9961 407.298 63.9961C394.097 63.9961 383.396 74.6976 383.396 87.8985C383.396 101.099 394.097 111.801 407.298 111.801Z" fill="#1F9D57" stroke="white" stroke-width="3.58537"/>
<path d="M397.139 87.9012L404.907 95.6695L418.054 80.7305" stroke="white" stroke-width="4.18293" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M309.923 220.633C309.923 223.422 308.165 225.355 305.036 226.223L304.45 225.062C306.747 224.441 308.071 223.27 308.329 221.828H305.024V220.633H309.923ZM313.38 220.023V225.988H311.892V223.773H309.993V222.555H311.892V220.023H313.38ZM313.38 226.41V230.547H306.313V226.41H313.38ZM307.778 227.582V229.375H311.903V227.582H307.778ZM323.458 225.297V226.48H320.388V228.285H324.524V229.48H314.763V228.285H318.876V226.48H315.911V220.75H323.376V221.945H317.435V223.012H323.13V224.184H317.435V225.297H323.458ZM331.11 220.445C332.669 220.445 333.794 221.324 333.794 222.613C333.794 223.656 333.026 224.453 331.884 224.699V225.473C332.716 225.426 333.554 225.35 334.333 225.238L334.45 226.328C332.259 226.715 329.81 226.762 328.028 226.762L327.876 225.578C328.614 225.578 329.476 225.572 330.384 225.543V224.711C329.206 224.477 328.415 223.674 328.427 222.613C328.415 221.324 329.54 220.445 331.11 220.445ZM331.11 221.57C330.349 221.582 329.81 221.945 329.821 222.613C329.81 223.258 330.349 223.645 331.11 223.645C331.872 223.645 332.388 223.258 332.388 222.613C332.388 221.945 331.872 221.582 331.11 221.57ZM336.431 220.023V223.375H337.79V224.617H336.431V228.156H334.931V220.023H336.431ZM336.794 229.281V230.477H329.282V227.441H330.782V229.281H336.794ZM348.032 228.262V229.492H338.271V228.262H340.767V226.633H339.396V223.047H345.431V221.898H339.384V220.703H346.907V224.242H340.896V225.426H347.153V226.633H345.642V228.262H348.032ZM342.22 228.262H344.177V226.633H342.22V228.262Z" fill="#15683A"/>
</g>
<defs>
<filter id="filter0_d_4886_256514" x="0.000195265" y="-0.000781298" width="666.4" height="303.201" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="3.2" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_4886_256514"/>
<feOffset/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.937255 0 0 0 0 0.964706 0 0 0 0 1 0 0 0 1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4886_256514"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4886_256514" result="shape"/>
</filter>
</defs>
</svg>`;

type Slide = { svg: string; title: string; description: string };

const SLIDES: Slide[] = [
  {
    svg: FRAME_1,
    title: "검토 결과를 한눈에 확인하세요",
    description:
      "본문-주석 매칭, 합계 검증, 교정 내역까지 — 확인이 필요한 항목만 모아서 보여드려요.",
  },
  {
    svg: FRAME_2,
    title: "발견 즉시, 그 자리에서 수정",
    description: "문제가 있는 값은 셀을 클릭해 바로 고칠 수 있어요.",
  },
  {
    svg: FRAME_3,
    title: "재검토로 확실하게 마무리",
    description: "수정한 내용은 다시 검토해 이상이 없는지 확인하세요.",
  },
];

// 슬라이드 유지 시간(전환 애니메이션 포함). 0.7s는 설명을 읽기엔 빨라 넉넉히 잡음.
const SLIDE_INTERVAL_MS = 900;

// 2·3번 슬라이드는 편집 기능(베타) 정식 출시 전까지 노출하지 않는다.
// 출시 시 true로 되돌리면 기존 로테이션이 그대로 복구된다.
const SLIDE_ROTATION_ENABLED = false;

export const ReviewLoadingOnboarding = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!SLIDE_ROTATION_ENABLED) return;
    const timer = setInterval(
      () => setIndex((prev) => (prev + 1) % SLIDES.length),
      SLIDE_INTERVAL_MS,
    );
    return () => clearInterval(timer);
  }, []);

  const slide = SLIDES[index];

  return (
    <div className="relative flex h-[400px] w-full max-w-[600px] justify-center overflow-hidden">
      {/* 기존 슬라이드는 왼쪽으로 사라지고, 새 슬라이드는 오른쪽에서 들어온다 */}
      <AnimatePresence>
        <motion.div
          key={index}
          className="absolute inset-0 flex flex-col items-center gap-6"
          initial={{ x: 36, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -36, opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <div
            className="w-full [&>svg]:h-auto [&>svg]:w-full"
            // 디자이너 제공 정적 SVG (사용자 입력 아님)
            dangerouslySetInnerHTML={{ __html: slide.svg }}
          />
          <div className="flex flex-col items-center gap-2 px-4 text-center">
            <p className="text-[22px] font-bold text-label-normal">
              {slide.title}
            </p>
            <p className="max-w-[480px] text-[16px] text-label-alternative">
              {slide.description}
            </p>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
